import React, { useCallback, useContext } from 'react';

import { ClearIndicatorProps } from 'react-select';
import { BreakpointsContext } from '../../../providers/Breakpoints';
import { Icon } from '@src/atoms/Icon';

export const SelectClearIndicator = (props: ClearIndicatorProps) => {
  const {
    innerProps: { ref, ...restInnerProps },
    selectProps,
    clearValue,
  } = props;

  const { isMobile } = useContext(BreakpointsContext);

  const handleMouseDown: React.MouseEventHandler<HTMLDivElement> = useCallback(
    (event) => {
      event.stopPropagation();
      event.preventDefault();

      if (isMobile) {
        clearValue();
      } else if (restInnerProps.onMouseDown) {
        restInnerProps.onMouseDown(event);
      }
    },
    [isMobile, clearValue, restInnerProps],
  );

  const handleTouchEnd: React.TouchEventHandler<HTMLDivElement> = useCallback(
    (event) => {
      event.stopPropagation();
      event.preventDefault();

      if (isMobile) {
        clearValue();
      } else if (restInnerProps.onTouchEnd) {
        restInnerProps.onTouchEnd(event);
      }
    },
    [isMobile, clearValue, restInnerProps],
  );

  return (
    <div
      {...restInnerProps}
      data-id={`${selectProps['data-id']}_clearIndicator`}
      onMouseDown={handleMouseDown}
      onTouchEnd={handleTouchEnd}
      ref={ref}
    >
      <Icon name="close" size="md-light" />
    </div>
  );
};
